import {Component} from '@angular/core';
import {FieldType, FieldTypeConfig, FormlyModule} from '@ngx-formly/core';
import {TranslateModule} from '@ngx-translate/core';
import {ReactiveFormsModule} from '@angular/forms';
import {AlertController, IonItem, IonLabel, IonText, IonTextarea} from "@ionic/angular/standalone";

@Component({
  selector: 'string-formly-type',
  template: `
    <ion-item lines="full">
      <div style="width: 100%; padding-top: 8px;">
        <ion-text (click)="ionTextarea.setFocus()" [color]="showError && formControl.errors ? 'danger': ''">
          <ion-label style="display: block;">
            {{ props.label }}
            <ion-text color="medium">
              @if (!props.required) {
                <small>(Optional)</small>
              }
            </ion-text>
            @if (props.description) {
              <button style="background: none; margin-left: 8px;" (click)="showInfo()">ⓘ</button>
            }
            <!--            @if (showError) {-->
            <!--              <formly-validation-message style="color: var(&#45;&#45;ion-color-danger)"-->
            <!--                                         [field]="field"></formly-validation-message>-->
            <!--            }-->
          </ion-label>
        </ion-text>

        <ion-textarea [autoGrow]="true" [rows]="3" aria-label=" " #ionTextarea [formControl]="formControl"
                      [formlyAttributes]="field"
                      style="color: var(--ion-color-medium)" [placeholder]="'(Empty)' | translate"
                      [id]="String(field.key)" [attr.data-testid]="field.key"
                      [attr.data-label]="props.label"></ion-textarea>
        @if (props.maxLength) {
          <ion-text color="medium" style="font-size: 12px;">
            {{ 'Characters' | translate:{count: formControl?.value?.length || 0, max: props.maxLength} }}
          </ion-text>
        }
      </div>
    </ion-item>
  `,
  imports: [TranslateModule, FormlyModule, ReactiveFormsModule, IonTextarea, IonText, IonLabel, IonItem]
})
export class TextareaFormlyType extends FieldType<FieldTypeConfig> {

  public constructor(private alertController: AlertController) {
    super();
  }

  public showInfo() {
    this.alertController.create({
      header: 'Info',
      message: this.props.description,
      buttons: ['OK']
    }).then(alert => alert.present());
  }

  protected readonly JSON = JSON;
  protected readonly String = String;
}
